import { apiClient } from "../api/apiclient"

export const PostInstructions = (token, instruction, document) => {
    const formData = new FormData();
    formData.append("instruction", instruction);
    if (document) {
        formData.append("document", document);
    }

    return apiClient.post("/instruction", formData, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
        },
    });
};
